<template>
  <div
    class="actionbar-container bg-white w-full flex flex-row h-10 rounded-default items-center pr-5 pl-2 justify-between"
  >
    <ButtonSelect
      :data="[
        {
          active: true,
          icon: {
            type: 'grid',
            color: 'grey-darkest',
            size: '20px',
          },
        },
      ]"
    />

    <!--    { active: false, icon: { type: 'list', color: 'grey-darkest', size: '20px', }, }, -->

    <KSelect
      :data="[
        {
          name: 'Data',
          value: 'created_at',
        },
        {
          name: 'Tipo',
          value: 'tipo_id',
        },
        {
          name: 'Ordem',
          value: 'ordem',
        },
      ]"
      @on-change="$emit('on-change', $event)"
    />
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import ButtonSelect from '@/layout/components/button-select/button-select.vue';
import KSelect from '@/layout/components/select/KSelect';

export default {
	name: 'ActionBar',
	components: {
		ButtonSelect,
		KSelect,
	},
};
</script>

<style lang="scss" scoped>
@import '~@/style/Global.css';

.actionbar-container {
	height: 50px;
}
</style>
